/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Summary_VsInputs */

const en_us2_progress_report_summary_vs = /** @type {(inputs: Progress_Report_Summary_VsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Arrows: against the whole previous week`);
	return /** @type {LocalizedString} */ (`Arrows: against the whole previous month`)
	
};

const pt_br2_progress_report_summary_vs = /** @type {(inputs: Progress_Report_Summary_VsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Setas: contra a semana anterior inteira`);
	return /** @type {LocalizedString} */ (`Setas: contra o mês anterior inteiro`)
	
};

const es_419_progress_report_summary_vs = /** @type {(inputs: Progress_Report_Summary_VsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Flechas: frente a toda la semana anterior`);
	return /** @type {LocalizedString} */ (`Flechas: frente a todo el mes anterior`)
	
};

const pt_pt2_progress_report_summary_vs = /** @type {(inputs: Progress_Report_Summary_VsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Setas: face à semana anterior inteira`);
	return /** @type {LocalizedString} */ (`Setas: face ao mês anterior inteiro`)
	
};

const fr_fr2_progress_report_summary_vs = /** @type {(inputs: Progress_Report_Summary_VsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Flèches : par rapport à toute la semaine précédente`);
	return /** @type {LocalizedString} */ (`Flèches : par rapport à tout le mois précédent`)
	
};

const de_de2_progress_report_summary_vs = /** @type {(inputs: Progress_Report_Summary_VsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Pfeile: im Vergleich zur ganzen Vorwoche`);
	return /** @type {LocalizedString} */ (`Pfeile: im Vergleich zum ganzen Vormonat`)
	
};

const it_it2_progress_report_summary_vs = /** @type {(inputs: Progress_Report_Summary_VsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Frecce: rispetto all'intera settimana precedente`);
	return /** @type {LocalizedString} */ (`Frecce: rispetto all'intero mese precedente`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "Arrows: against the whole previous week" |
* | * | "Arrows: against the whole previous month" |
*
* @param {Progress_Report_Summary_VsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_summary_vs = /** @type {((inputs: Progress_Report_Summary_VsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Summary_VsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_summary_vs(inputs)
	if (locale === "es-419") return es_419_progress_report_summary_vs(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_summary_vs(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_summary_vs(inputs)
	if (locale === "de-DE") return de_de2_progress_report_summary_vs(inputs)
	if (locale === "it-IT") return it_it2_progress_report_summary_vs(inputs)
	return en_us2_progress_report_summary_vs(inputs)
});
export { progress_report_summary_vs as "progress-report.summary_vs" }